<template>
  <form class="form-inline my-2 my-lg-0 search-from-n" @submit.prevent="searchForm">
    <el-autocomplete
      class="inline-input el-ac-zindexed"
      v-model="search"
      :fetch-suggestions="querySearchAsync"
      placeholder="Search for movies, tvshows..."
      :trigger-on-focus="false"
      @select="handleSelect"
      prefix-icon="el-icon-search"
    ></el-autocomplete>
  </form>
</template>

<script>
export default {

  data() {
    return {
      search: '',
    }
  },

  mounted() {
    this.search = this.$route.query.title;
  },
  
  methods: {
    searchForm() {
      if (this.search == '') {
        return false;
      }

      const query = {
        ...this.$route.query, 
        title: this.search,
        page: 1
      }

      this.$router.push({
        name: 'search',
        query
      });
    },

    querySearchAsync(query, send) {
      const response = [
        {link: 'https://www.google.com', value: 'Game of thrones'},
        {link: 'https://www.google.com', value: 'Horror Movies'},
        {link: 'https://www.google.com', value: 'Avengers'},
      ];

      if (!query) return;

      send(
        response.filter(v => v.value.toLowerCase() == query.toLowerCase())
      );
    },

    handleSelect(item) {
      console.log('searched item', item);
    }
  },

  watch: {
    $route() {
      this.search = this.$route.query.title;
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
<style lang="scss">
.el-autocomplete-suggestion {
  z-index: 21759900 !important;
}
</style>